(function(jQuery, Drupal) {
  'use strict';

  Drupal.behaviors.inspirationEverywhere = {
    attach: function(context, settings) {
      const $inspoBlock = jQuery('.block-views-blockinspiration-everywhere-block-1');
      let $bgImages = [];
      let rotate = 0;

      /**
       * Set the background image on the block and iterate the rotate variable
       */
      const setBlockBg = function() {
        // get the next image and set as background
        let src = $bgImages.eq(rotate).attr('data-src');
        if (!src) {
          src = $bgImages.eq(rotate).attr('src');
        }
        if (!$inspoBlock.hasClass('b-lazy')) {
          $inspoBlock.addClass('b-lazy');
        }
        if ($inspoBlock.hasClass('b-loaded')) {
          $inspoBlock.removeClass('b-loaded');
        }
        $inspoBlock.attr('data-src', src);
        window.blazy.revalidate();
        // iterate to cycle through backgrounds
        rotate++;
        if (rotate >= $bgImages.length) {
          rotate = 0;
        }
      };

      /**
       * Get the available images and set the initial background and button on click
       */
      const initCanSlider = function() {
        if (!window.inspirationEverywhere && $inspoBlock.length > 0) {
          window.inspirationEverywhere = true;
          const prevBtn = '<button type="button" data-role="none" class="slick-prev slick-arrow" aria-label="Previous">Previous</button>';
          const nextBtn = '<button type="button" data-role="none" class="slick-next slick-arrow" aria-label="Next">Next</button>';
          const $inspirationEverywhere = jQuery('.view-inspiration-everywhere .view-content');
          if ($inspirationEverywhere.length > 0) {
            $inspirationEverywhere.each(function() {
              jQuery(this)
                .on('afterChange', function() {
                  window.blazy.revalidate();
                })
                .slick({
                  dots: false,
                  nextArrow: nextBtn,
                  prevArrow: prevBtn,
                  slidesToScroll: 1,
                  initialSlide: 5, // ensure something in the middle
                  adaptiveHeight: false,
                  variableWidth: true,
                  centerMode: true,
                  infinite: true
                });
            });
          }
          // collect the images, set the initial bg, and onClick
          $bgImages = $inspoBlock.find('.attachment-before .field--name-field-media-image img');
          setBlockBg();

          jQuery('.change-bg').click(function() {
            setBlockBg();
          });
        }
      };

      jQuery(document).ready(function() {
        initCanSlider();
      });
    }
  };
})(jQuery, Drupal);
